import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { UserService } from '../../Service/User/user.service';
import { FormStateService } from '../service-provider/add-sp-new-component/form-state.service';
import { ServiceAdvisorFormStateService } from '../service-advisors/service/service-advisor-formStateService';
import { ToastService } from '../../Service/ToastService/toast.service';
import { Router } from '@angular/router';
import { ServiceProviderService } from '../../Service/Service-providers/service-provider.service';
import { take } from 'rxjs';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent implements OnInit {
  form = new FormGroup({});
  model: any = {
    firstName: '',
    lastName: '',
    email: '',
    userProfilePhotoId: '',
  };
  options: FormlyFormOptions = {};
  isLoading = false;
  isProfileLoaded = false;

  fields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'p-fluid p-formgrid p-grid',
      fieldGroup: [
        {
          fieldGroupClassName: 'grid p-fluid',
          fieldGroup: [
            {
              className: 'field field1',
              type: 'input',
              wrappers: ['form-field-horizontal'],
              key: 'firstName',
              templateOptions: {
                placeholder: 'First Name',
                required: true,
                label: 'Name',
              },
            },
            {
              className: ' col',
              key: 'lastName',
              type: 'input',
              templateOptions: {
                placeholder: 'Last Name',
                label: 'Name',
                required: true,
                hideLabel: true,
              },
            },
          ],
        },
        {
          template: '<div class="horizontal-line"></div>',
        },
        // {
        //   template: `<div class="mt-3 "></div>`,
        // },

        {
          className: 'p-fluid',
          key: 'email',
          wrappers: ['form-field-horizontal'],
          type: 'input',
          templateOptions: {
            label: 'Email address',
            type: 'email',
            placeholder: 'example@domain.com',
            required: true,
            // hideLabel: true,
          },
          validators: {
            email: {
              expression: (c: AbstractControl) =>
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                  c.value
                ),
              message: (error: any, field: FormlyFieldConfig) =>
                `${field.formControl?.value} is not a valid Email Address`,
            },
          },
        },
        {
          template: '<div class="horizontal-line"></div>',
        },
        // {
        //   template: `<div class="mt-3"></div>`,
        // },
        {
          className: 'p-fluid',
          key: 'userProfilePhotoId',
          wrappers: ['form-field-horizontal'],
          type: 'file-photoupload',
          templateOptions: {
            label: 'Your photo',
            placeholder: 'Click to upload or drag and drop',
            description: 'SVG, PNG, JPG or GIF (max. 800x400px)',
            className: 'upload-photo',
            //onChange: (field: any, event: any) => this.onFileSelected(event),
          },
        },
      ],
    },
  ];
  data: any;
  constructor(
    private api: UserService,
    private serviceAPI: ServiceProviderService,
    private serviceAdvisorFormStateService: ServiceAdvisorFormStateService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) { }
  ngOnInit() {
    this.profilDetails();
  }
  profilDetails() {
    console.log('profilDetails called');
    this.api.getLogiProfile().pipe(take(1)).subscribe((res: any) => {
      console.log('API Response:', res);
      this.patchProfileInfo(res);
    });
  }

  patchProfileInfo(res: any) {
    this.model.firstName = res?.firstName || '';
    this.model.lastName = res?.lastName || '';
    this.model.email = res?.emailAddress || '';

    const photo = res.profilePhoto;
    if (photo && photo.filePath) {
      const fileUrl = `${photo.filePath.replace(/^\//, '')}`;
      console.log('File URL:', fileUrl);

      // Store in service state for retrieval
      this.serviceAdvisorFormStateService.setProfilePicture({
        fileName: photo.fileName,
        fileUrl: fileUrl,
        fileId: photo.userProfilePhotoId,
      });

      //  Patch the fileUrl to Formly field
      this.form.patchValue({ userProfilePhotoId: fileUrl });

      //  Ensure Formly renders only after patching
      setTimeout(() => {
        this.isProfileLoaded = true;
        this.cdr.detectChanges();
      }, 100);
    } else {
      this.isProfileLoaded = true;  // No image but still render form
    }
  }


  onSubmit() {
    const data = this.prepareUpdateData(this.form.value);
    console.log(data);
    this.api.updateProfile(data).subscribe(
      (res: any) => {
        const token: any = localStorage.getItem('token');

        console.log(token);
        this.serviceAPI.newToken(token).subscribe((res: any) => {
          console.log(res);
          this.serviceAPI.storeToken(token);
          this.serviceAPI.storePersonalDetails(token);
          this.api.updateProfileData(res);
        });

        this.handleSuccess('The profile page was updated successfully.');
      },
      (error) => {
        console.log(error);
        this.handleError('An error occurred while updating. Please try again.');
      }
    );
  }

  prepareUpdateData(profileData: any) {
    const uploadedFileId =
      this.serviceAdvisorFormStateService.getProfilePictureFileId();      //getUploadedFileId('profilePic');

    return {
      firstName: profileData.firstName,
      lastName: profileData.lastName,
      userProfilePhotoId: uploadedFileId || 4,
    };
  }

  // onCancel() {
  //   this.router.navigate(['/service-provider']);
  // }
  onCancel() {
    // const user = JSON.parse(localStorage.getItem('user') || '{}');
    // const basePath = user.accessType === 4 ? '/distributor' : '/admin';
    // this.router.navigate([`${basePath}/service-distributor`])
      const user = JSON.parse(localStorage.getItem('user') || '{}');
    
      let basePath = '/admin';
    
      if (user.accessType === 4) {
        basePath = '/distributor-partners';
      }
    
      const route =
        user.accessType === 4
          ? `${basePath}/user-dashboard`
          : `${basePath}/user-dashboard`;
    
      this.router.navigate([route]);
    
  }
  
  handleSuccess(message: string): void {
    this.isLoading = false;
    this.toastService.showToast(message, 'success');
    // setTimeout(() => {
    //   this.router.navigate(['/service-provider']);
    // }, 1500);
  }

  handleError(message: string): void {
    this.isLoading = false;
    this.toastService.showToast(message, 'error');
  }


  // In ProfileComponent
  // onFileSelected(event: any) {
  //   if (event.target.files.length > 0) {
  //     const file = event.target.files[0];
  //     console.log("Selected File:", file);

  //     this.serviceAPI.updateProfile(file).subscribe(
  //       (res: any) => {
  //         console.log("Upload API Response:", res);

  //         if (res?.fileId && res?.filePath) {
  //           this.serviceAdvisorFormStateService.setProfilePicture({
  //             fileName: file.name,
  //             fileUrl: res.filePath,
  //             fileId: res.fileId,
  //           });

  //           console.log("Profile Picture Stored:", res.filePath);
  //         } else {
  //           console.error("Upload API Failed! Missing fileId or filePath.");
  //         }
  //       },
  //       (error) => console.error("Upload API Error:", error)
  //     );
  //   }
  // }



}
